import React from 'react';

import classNames from 'classnames';

import { Link } from 'react-router-dom';

import VerticalAuthorCard from 'rebook/apps/books/components/VerticalAuthorCard';
import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import pluralize from 'rebook/apps/utils/text/pluralize';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';

import styles from './style.scss';


const NicheCatalogBestAuthors = ({ bestAuthors, bestAuthorsCounter, link, linkText }) => (
  <div className="billetContainerNoOverflow">
    {bestAuthors
      ? (
        <React.Fragment>
          <div >
            <div className={styles.title}>
              <div>
                <div className="title-2">Авторы</div>
                <span className={styles.subtitle}>
                  {numberWithSpace(bestAuthorsCounter)}&nbsp;
                  {pluralize(bestAuthorsCounter, 'автор', 'автора', 'авторов')}
                </span>
              </div>
              <Link to={link} className={styles.link}>
                {linkText.length > 0 && (
                  <span className={classNames('link', styles.linkText)}>{linkText}</span>
                )}
              </Link>
            </div>
          </div>
          <ContentCarousel>
            {bestAuthors.map((item, index) => <VerticalAuthorCard key={index} author={item} />)}
          </ContentCarousel>
        </React.Fragment>
      )
      : (
        <React.Fragment>
          <div className="billetContainerWrapper">
            <div className={styles.titleEmpty} />
            <div className={styles.subTitleEmpty} />
          </div>
          <VerticalBookCardList />
        </React.Fragment>
      )
    }
  </div>
);

export default NicheCatalogBestAuthors;
